import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminEventosFallidosPage } from "@/features/admin-eventos-fallidos/components/AdminEventosFallidosPage";

/** Ruta `/admin/eventos-fallidos` · eventos del outbox que fallaron, por módulo (hotspot 55). */
export const Route = createFileRoute("/_authed-tw/admin/eventos-fallidos")({
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminEventosFallidos]}>
      <AdminEventosFallidosPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
